import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { XiloDialogHeader } from '../dialog/dialog.component';
/**
* @description The header element is a component of the xilo library
* @example 
  <xilo-lib-dialog-header 
      [header]="{
        headerTitle: 'test',
        showClose: true,
        showHeaderBorder: false 
      }"
  ></xilo-lib-dialog-header>
* @param headerTitle show show content for the header.
* @param showClose should show close icon
* @param showHeaderBorder should show header border
*/
@Component({
  selector: 'xilo-lib-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['../dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
  @Input() header: XiloDialogHeader;

  close() {
    // this.dialogRef.close();
  }
}
